export default [
  {
    path: '/admin/defines/donation-types',
    name: 'DonationTypes',
    component: () => import('@/views/Admin/Defines/Donation_types/Index.vue'),
    meta: {
      pageTitle: 'Gelir Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/donation-types/add',
    name: 'DonationTypeAdd',
    component: () => import('@/views/Admin/Defines/Donation_types/Add.vue'),
    meta: {
      pageTitle: 'Gelir Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/donation-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/donation-types/edit/:id',
    name: 'DonationTypeEdit',
    component: () => import('@/views/Admin/Defines/Donation_types/Edit.vue'),
    meta: {
      pageTitle: 'Gelir Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/donation-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
